/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * View model returned from GetDatasets
 */
export interface DatasetSimpleIntegrationViewModel {
  /**
   * Dataset Id
   */
  id?: string;
  /**
   * Dataset name, max length 100
   */
  name?: string | null;
  /**
   * Dataset acronym, max length 20
   */
  acronym?: string | null;
  /**
   * True if dataset is inactive, false if active
   */
  inactive?: boolean;
}
